import { useGetUser, useGetSubscriptionPlans } from '../../hooks/api-hooks';
import { useState } from 'react';
import Pricing from './pricing';
import { CheckIcon } from '@heroicons/react/20/solid';

export default function Membership() {
  const { data: user, isLoading: userLoading, error: userError } = useGetUser();
  const {
    data: plans = [],
  } = useGetSubscriptionPlans();
  const [isLoadingCancel, setIsLoadingCancel] = useState(false);

  const handleCancelSubscription = async () => {
    setIsLoadingCancel(true);
    // TODO: Make API call to cancel user's subscription
    // await cancelUserSubscription();
    setIsLoadingCancel(false);
  };


  const currentPlanCode = user?.subscription?.code;
  const currentPlanStatus = user?.subscription?.status;

  const currentPlan = plans.find((plan) => plan.code === currentPlanCode);
  const currentPlanLabel = currentPlan?.label || 'Unknown Plan';

  const formatLimit = (limit: number) => {
    return limit === -1 ? 'Unlimited' : limit.toString();
  };

  return (
    <div className="divide-y divide-gray-200">
      {/* Current Membership Card */}
      <div className="max-w-3xl py-8 px-4 sm:px-6 lg:px-8">
        <section aria-labelledby="plan-heading">
          <div className="bg-white shadow sm:rounded-lg">
            <div className="px-4 py-5 sm:p-6">
              <h2
                id="plan-heading"
                className="text-lg leading-6 font-medium text-gray-900"
              >
                Current Membership
              </h2>
              <div className="mt-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-indigo-50">
                      <CheckIcon
                        className="h-6 w-6 text-indigo-600"
                        aria-hidden="true"
                      />
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-lg font-medium text-gray-900">
                      {currentPlanLabel} Plan
                    </h3>
                    <p className="mt-2 text-sm text-gray-500">
                      Subscription Status: <strong>{currentPlanStatus}</strong>
                    </p>
                    {user?.subscription?.currentPeriodEnd && (
                      <p className="mt-2 text-sm text-gray-500">
                        Next Billing Date:{' '}
                        <strong>{user.subscription.currentPeriodEnd}</strong>
                      </p>
                    )}
                    {currentPlan?.features && (
                      <ul className="mt-4 space-y-2">
                        {currentPlan.features.map((feature) => (
                          <li
                            key={feature.name}
                            className="flex items-center text-sm text-gray-500"
                          >
                            <CheckIcon
                              className="h-5 w-5 text-indigo-600 flex-shrink-0"
                              aria-hidden="true"
                            />
                            <span className="ml-2">
                              {feature.description.replace(
                                '%',
                                formatLimit(feature.limit)
                              )}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              </div>

              {currentPlanStatus === 'active' &&
                currentPlanCode !== 'neoface_free' && (
                  <div className="mt-6">
                    <button
                      type="button"
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                      onClick={handleCancelSubscription}
                      disabled={isLoadingCancel}
                    >
                      {isLoadingCancel ? 'Cancelling...' : 'Cancel Subscription'}
                    </button>
                  </div>
                )}
            </div>
          </div>
        </section>
      </div>

      {/* Upgrade Plan Section */}
      {/*<div className="max-w-7xl py-8 px-4 sm:px-6 lg:px-8">*/}
      {/*  <section aria-labelledby="upgrade-heading">*/}
      {/*    <div className="text-center">*/}
      {/*      <h2*/}
      {/*        id="upgrade-heading"*/}
      {/*        className="text-2xl font-bold leading-7 text-gray-900"*/}
      {/*      >*/}
      {/*        Upgrade Plan*/}
      {/*      </h2>*/}
      {/*      <p className="mt-2 text-lg text-gray-600">*/}
      {/*        Upgrade your plan to unlock more features.*/}
      {/*      </p>*/}
      {/*    </div>*/}
      {/*    <div className="mt-12">*/}
      {/*      <Pricing />*/}
      {/*    </div>*/}
      {/*  </section>*/}
      {/*</div>*/}
    </div>
  );
}
